import { render, staticRenderFns } from "./DeviceListCard.vue?vue&type=template&id=1088fce6&scoped=true&"
import script from "./DeviceListCard.vue?vue&type=script&lang=js&"
export * from "./DeviceListCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceListCard.vue?vue&type=style&index=0&id=1088fce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1088fce6",
  null
  
)

export default component.exports